import React from "react";
import { PRINCIPIOS, RETRO } from "@/content/site";
import { Container, Eyebrow, Body, Reveal, EpistemicTag } from "@/components/site/ui";
import FeedbackLoops from "@/components/home/FeedbackLoops";

// Problemas conectados — bloco de diagrama, sem fotografia.
const Retroalimentacoes = () => (
    <section data-testid="home-retro" data-section-id="retro" className="relative bg-[#0E2018] py-24 md:py-32 border-t border-[#1B3025]">
        <Container className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
            <Reveal className="lg:col-span-6 flex flex-col gap-7">
                <Eyebrow>Policrise e retroalimentação</Eyebrow>
                <h2 className="font-serif font-light text-[30px] sm:text-[38px] lg:text-[44px] leading-[1.1] tracking-[-0.01em] text-[#F2EFE5]">{RETRO.titulo}</h2>
                <Body>{RETRO.policrise}</Body>
                <p data-testid="retro-contexto" className="font-serif italic text-[17px] leading-[1.5] text-[#D7D1BF]">{RETRO.contexto}</p>
                <p className="pt-6 border-t border-[#1B3025] font-serif italic text-[17px] leading-[1.5] text-[#D7D1BF]">{PRINCIPIOS.problema}</p>
            </Reveal>
            <Reveal className="lg:col-span-6 max-w-[460px] mx-auto w-full" delay={200}>
                <div className="bg-[#F2EFE5] rounded-sm p-6"><FeedbackLoops /></div>
                <div className="mt-4 flex flex-col items-center gap-2 text-center">
                    <EpistemicTag tipo="lente-teorica" />
                    <p data-testid="diagrama-nota" className="font-sans text-[11px] leading-[1.6] text-[#7E8978]">{RETRO.nota}</p>
                    <p data-testid="diagrama-nota2" className="font-sans text-[10px] leading-[1.6] text-[#7E8978]/80">{RETRO.nota2}</p>
                </div>
            </Reveal>
        </Container>
    </section>
);

export default Retroalimentacoes;
